import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate } from "react-router-dom";
import { paths } from "../../../routes/paths";
import { useConsole, jobIdOf } from "./ConsoleContext";
import tokens from "../../theme/tokens";

const { color, font } = tokens;

/**
 * /dashboard/jobs — no job in the URL yet. Land the user on their first job so the
 * console is the default view, rather than making them pick from a grid first.
 */
const ConsoleIndex = () => {
  const { jobs, jobsLoading, jobsError } = useConsole();

  if (jobsLoading) {
    return (
      <Box sx={{ flex: 1, display: "grid", placeItems: "center" }}>
        <CircularProgress size={22} />
      </Box>
    );
  }

  if (jobs.length) {
    return <Navigate to={`${paths.v1.jobs}/${jobIdOf(jobs[0])}`} replace />;
  }

  return (
    <Box sx={{ flex: 1, display: "grid", placeItems: "center", textAlign: "center" }}>
      <Box>
        <Box sx={{ font: `600 16px ${font.sans}`, color: color.text, mb: 1 }}>
          {jobsError ? "Couldn't load your jobs" : "No jobs yet"}
        </Box>
        <Box sx={{ font: `400 13px ${font.sans}`, color: color.textSecondary }}>
          {jobsError || 'Use "＋ New" in the rail to create your first job.'}
        </Box>
      </Box>
    </Box>
  );
};

export default ConsoleIndex;
